export enum DialogHeaderIcon {
	Success = "success",
	SuccessCircle = "success-circle",
	RejectCircle = "reject-circle",
	Triangle = "triangle",
	Edit = "edit",
	EditCircle = "edit-circle",
	ArrowLeft = "arrow-left",
	Individual = "individual",
	FileEdit = "file-edit",
	Sms = "sms",
	CircleArrowLeft = "circle-arrow-left",
	Logout = "logout-icon",
	PropertyEdit = "property-edit",
	Close = "close",
	Messages = "messages",
	Location = "location",
	Return = "return",
	UserAdd = "user-add",
	UnassignedArbitratorInvitation = "unassigned-arbitrator-invitation",
	ExpertSecondment = "expert-secondment",
	AddCircle = "add-circle",
	MemoSubmission = "memo-submission",
	ChangeArbitrationPlan = "change-arbitration-plan",
	Arbitrator = "arbitrator",
	ArbitratorAssignment = "arbitrator-assignment",
	Money = "money",
	Email = "email",
	Phone = "phone",
	Document = "document",
	ProfileEditAvatar = "profile-edit-avatar",
	TermsConditions = "terms-conditions",
	Invoice = "invoice",
	CourtLaw = "court-law",
	CalendarCircle = "calendar_circle",
	DeliberationSession = "deliberation-session",
	RejectArbitration = "reject-arbitration",
	RejectConfirmation = "reject-confirmation",
	InformationCircle = "information-circle",
	BasicStatute = "basic-statute",
	RankDescending = "rank-descending",
}

export const DIALOG_HEADER_ICON_DEFAULT_SIZE = 22;

const DIALOG_HEADER_ICON_SIZES: Partial<Record<DialogHeaderIcon, number>> = {
	[DialogHeaderIcon.Success]: 20,
	[DialogHeaderIcon.SuccessCircle]: 20,
	[DialogHeaderIcon.EditCircle]: 30,
	[DialogHeaderIcon.ProfileEditAvatar]: 30,
	[DialogHeaderIcon.Invoice]: 24,
	[DialogHeaderIcon.RankDescending]: 22,
};

export function dialogHeaderIconSize(icon: DialogHeaderIcon | string, override?: number): number {
	if (override != null) {
		return override;
	}

	return DIALOG_HEADER_ICON_SIZES[icon as DialogHeaderIcon] ?? DIALOG_HEADER_ICON_DEFAULT_SIZE;
}

export function isDialogHeaderIconReject(icon: DialogHeaderIcon | string): boolean {
	return icon === DialogHeaderIcon.RejectCircle;
}

export function isDialogHeaderIconSuccess(icon: DialogHeaderIcon | string): boolean {
	return icon === DialogHeaderIcon.Success || icon === DialogHeaderIcon.SuccessCircle;
}

export function isDialogHeaderIconWarning(icon: DialogHeaderIcon | string): boolean {
	return icon === DialogHeaderIcon.Triangle;
}

export function isDialogHeaderIconLogout(icon: DialogHeaderIcon | string): boolean {
	return icon === DialogHeaderIcon.Logout;
}
